<template>
  <div>
    <Breadcrumbs :title="$t('lbl_EMPBE_OrderHistory')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="email-wrap bookmark-wrap">
        <div class="row">
          <listingVue></listingVue>
          <b-sidebar id="orderHistoryRightpopup" class="customSidebar" title="" right bg-variant="white" :shadow="true"
            backdrop :visible="currentRouteName != 'Order History'" ref="orderHistoryRightpopup">
            <router-view></router-view>
          </b-sidebar>

        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import listingVue from './orderhistorylisting.vue';

export default {
  components: {
    listingVue
  },
  data() {
    return {

    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  }
}
</script>